import httpClient from '../lib/http-client'
import { encrypt } from '../lib/utils'

const reportShareApi = {
  add (model) {
    return httpClient.post('/report-share', {
      ...model,
      password: encrypt(model.password, model.reportId)
    })
  },
  findTitleByToken (token) {
    return httpClient.get(`/report-share/title/${token}`)
  },
  findByToken (token, model, categoryId = null) {
    if (!token) {
      throw new Error('invalid token')
    }
    let url = `/report-share/${token}`

    if (categoryId) {
      url += `/${categoryId}`
    }
    return httpClient.post(url, {
      ...model,
      password: encrypt(model.password, model.reportId)
    })
  }
}

export default reportShareApi



// WEBPACK FOOTER //
// ./src/api/report-share.js